import { render } from "./LoadingBar.vue?vue&type=template&id=3a462bc2&scoped=true"
import script from "./LoadingBar.vue?vue&type=script&lang=js"
export * from "./LoadingBar.vue?vue&type=script&lang=js"

import "./LoadingBar.vue?vue&type=style&index=0&id=3a462bc2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a462bc2"]])

export default __exports__